import React, { Component } from 'react';
import CopyrightNotice from './CopyrightNotice';

class Footer extends Component {
  render() {
    return (
      <footer id="footer">
        <hr />
        <div className="footer-text">
          <CopyrightNotice year={2018} author="Aaron&nbsp;Horan" /> ·{' '}
          <a href="https://github.com/dmawrey">
            Website&nbsp;by&nbsp;Doug&nbsp;Mawrey
          </a>
        </div>
      </footer>
    );
  }
}

export default Footer;
